<template>
    <div>
        <TextField
          class="m1"
          :id="'start_date'"
          type="date"
          v-bind="textFieldConfig"
        
          :value="vatTerritoryObj.start_date||''"
          :placeholder="$t('start_date')"
          @valuechanged="onTextFieldValueChange"
          
        />
        <TextField
          class="m1"
          :id="'end_date'"
          type="date"
          v-bind="textFieldConfig"
        
          :value="vatTerritoryObj.end_date||''"
          :placeholder="$t('end_date')"
          @valuechanged="onTextFieldValueChange"
          
        />
    </div>
</template>

<script>

import Modal from '@dtplugins/modal/modal';

import {
  createTV,
  tv,
} from "../../../../models/text-value.model";
export default {
  components: {
    Modal,
  },
  props: {
    vatTerritoryData:{
      type: Object,
      default: {},
    }
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        // showValidationIcons: true,
        // immediateValidation: true,
      },
      licenceStatuses:[],
      validationResult: {},
      // vatTerritoryObj:{}
    };
  },
  // mounted:async function() {
  //     this.vatTerritoryObj=this.vatTerritoryData.vat_territory
  // },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },
    vatTerritoryObj:function(){
        return this.vatTerritoryData.vat_territory||{}
    }


  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this.$emit('change',{key,value,objKey:'vat_territory'})
      //this.vatTerritoryObj[key]=value
    },
    onCancel: function() {
      console.log(":::")
      this.$emit("cancelled", true);
    },
    onOKClick: async function(e) {
      console.log()
      this.$emit('done', {...this.vatTerritoryObj});
    },
    //MARK: Methods
  }
};


</script>

<style lang="scss">
.cmp-catalog-licence-add-account {
}
</style>